module.exports = __webpack_public_path__ + "img/116.a95f7dd2.svg";